import styled from 'styled-components';

import { Button } from 'uiVe/common/components/Button/styles';

export const ButtonMenu = styled(Button)`
  aspect-ratio: 1;
  color: white;
`;
